// frontend/src/api/fleets.js
import { apiClient } from './index';

const fleetsApi = {
  createFleet: async (data) => {
    return await apiClient.post('/fleets/', data);
  },

  getMyFleets: async () => {
    return await apiClient.get('/fleets/');
  },

  deleteFleet: async (fleetId) => {
    return await apiClient.delete(`/fleets/${fleetId}`);
  },

  addVehicleToFleet: async (fleetId, vehicleData) => {
    return await apiClient.post(`/fleets/${fleetId}/vehicles`, vehicleData);
  },

  getFleetVehicles: async (fleetId) => {
    return await apiClient.get(`/fleets/${fleetId}/vehicles`);
  },

  // --- NEW FUNCTION ---
  removeVehicleFromFleet: async (fleetId, vehicleId) => {
    return await apiClient.delete(`/fleets/${fleetId}/vehicles/${vehicleId}`);
  }
};

export { fleetsApi };